import { XCircleIcon } from '@heroicons/react/20/solid';

export interface SuccessAlertProps {
  text: string;
}

export const ErrorAlert = (props: SuccessAlertProps) => {
  return (
    <div className="rounded-md bg-error-subtle p-4">
      <div className="flex">
        <div className="shrink-0">
          <XCircleIcon aria-hidden="true" className="size-5 text-error" />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-sm text-error">{props.text}</p>
        </div>
      </div>
    </div>
  );
};
